import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'usimweb-loader',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    <div *ngIf="enabled">
      <mat-progress-spinner class="center" [diameter]="size" mode="indeterminate"></mat-progress-spinner>
      <p *ngIf="progress" style="margin-top: 3px; font-size: 14px">{{ progress | number : '1.2-2' }}%</p>
    </div>
  `,
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent {
  @Input() size: number = 50;

  @Input() enabled: boolean = false;

  @Input() progress: number = 0;
}
